import SimpleBar from "simplebar"
class ElcCookieConsent
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'elc-cookie-consent--bound'
            @.$scrollBar = undefined

            @.$el.classList.add 'elc-cookie-consent--bound'
            @.Init()
        return

    Init: ->
        @.$scrollBar = new SimpleBar @.$el, { autoHide: false }
        return

BindElcCookieConsents = ->
    document.querySelectorAll '.elc-cookie-consent:not(.elc-cookie-consent--bound)'
        .forEach (el) ->
            new ElcCookieConsent el
            return
    return

window.addEventListener 'bind-components', BindElcCookieConsents